<template>
  <div class="legal-page">
    <router-link to="/" class="back-link">
      <span class="material-icons">arrow_back</span>
      {{ $t('legal.backToHome') }}
    </router-link>
    <h1>{{ $t('legal.terms.title') }}</h1>
    <p class="last-updated">{{ $t('legal.terms.lastUpdated') }}</p>

    <h2>{{ $t('legal.terms.acceptance.title') }}</h2>
    <p>{{ $t('legal.terms.acceptance.content') }}</p>

    <h2>{{ $t('legal.terms.description.title') }}</h2>
    <p>{{ $t('legal.terms.description.content') }}</p>

    <h2>{{ $t('legal.terms.accounts.title') }}</h2>
    <p>{{ $t('legal.terms.accounts.content') }}</p>

    <h2>{{ $t('legal.terms.subscription.title') }}</h2>
    <p>{{ $t('legal.terms.subscription.content') }}</p>

    <h2>{{ $t('legal.terms.intellectualProperty.title') }}</h2>
    <p>{{ $t('legal.terms.intellectualProperty.content') }}</p>

    <h2>{{ $t('legal.terms.userContent.title') }}</h2>
    <p>{{ $t('legal.terms.userContent.content') }}</p>

    <h2>{{ $t('legal.terms.prohibited.title') }}</h2>
    <p>{{ $t('legal.terms.prohibited.content') }}</p>

    <h2>{{ $t('legal.terms.limitation.title') }}</h2>
    <p>{{ $t('legal.terms.limitation.content') }}</p>

    <h2>{{ $t('legal.terms.termination.title') }}</h2>
    <p>{{ $t('legal.terms.termination.content') }}</p>

    <h2>{{ $t('legal.terms.changes.title') }}</h2>
    <p>{{ $t('legal.terms.changes.content') }}</p>

    <h2>{{ $t('legal.terms.contact.title') }}</h2>
    <p>{{ $t('legal.terms.contact.content', { email: 'goodscriber@gmail.com' }) }}</p>
  </div>
</template>

<script>
export default {
  name: 'TermsOfService'
}
</script>

<style>
@import '../../styles/legal.css';
</style>
